import {
  getHeadingExtraClass,
  getHeadingTag,
} from "@atoms/Heading/utils/helpers";
import { HeadingProps } from "@atoms/Heading/utils/types";
import { cn } from "@util/helpers";

/**
 * Heading component that renders a heading element based on the provided level..
 */
const Heading = ({
  level,
  className,
  children,
}: HeadingProps): React.ReactElement => {
  const HeadingTag = getHeadingTag({ level });

  const headingClass = getHeadingExtraClass({ level });

  return (
    <HeadingTag
      className={cn(headingClass, className)}
      data-testid="heading-component"
    >
      {children}
    </HeadingTag>
  );
};

export default Heading;
